/* eslint-disable import/order */
import { Grid } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { endOfMonth, format, startOfMonth } from 'date-fns'
import queryString from 'query-string'

import styles from '../../../resources/theme/global'
import consts from '../../../util/consts'
import { useQueryParams } from '../../../util/utils'
import { fetchTeamProdutivityRelatoryInit } from '../TeamProdutivityRelatoryActions'

import BaseRelatoryPage from '../../../components/hooks/BaseRelatoryPage'
import Filter from './Filter'
import List from './List'

const getDefaultFilters = () => ({
  date_start: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
  date_end: format(endOfMonth(new Date()), 'yyyy-MM-dd'),
  page: 1,
  rows: consts.DEFAULT_PAGINATION,
})

function TeamProdutivityRelatory({ classes }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const query = useQueryParams(location.search)

  useEffect(() => {
    // A URL é a fonte única de verdade dos filtros. Sem query string,
    // aplica os filtros padrão (mês corrente) e deixa o efeito refazer a busca.
    if (!location.search) {
      history.replace(
        `${location.pathname}?${queryString.stringify(getDefaultFilters())}`
      )
      return
    }

    const { page = 1, rows = consts.DEFAULT_PAGINATION, ...filters } = query
    dispatch(fetchTeamProdutivityRelatoryInit(page, filters, rows))
  }, [location.search])

  return (
    <BaseRelatoryPage title="Produtividade por Equipe">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Filter classes={classes} />
        </Grid>

        <Grid item xs={12}>
          <List classes={classes} />
        </Grid>
      </Grid>
    </BaseRelatoryPage>
  )
}

export default withStyles(styles)(TeamProdutivityRelatory)
